// extracted by mini-css-extract-plugin
export default {"productGrid":"IZ-z","centerLink":"JZ-z","productSection":"KZ-z","item":"LZ-z","ctaButton":"MZ-z"};